import {useState} from "../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
export const useLastlyUsedWarehouse = () => {
  const [warehouseInfo, setWarehouseInfo] = useState(null);
  const setLastlyUsedWarehouse = (warehouse) => {
    if (warehouse) {
      window.localStorage.setItem("SYS_ERP_lastly_used_warehouse", JSON.stringify(warehouse));
    }
  };
  const setSelectWarehouse = (warehouse) => {
    if (warehouse) {
      console.log("warehousewarehouse", warehouse);
      setWarehouseInfo(warehouse);
    }
  };
  const getLastlyUsedWarehouse = () => {
    let warehouse = null;
    try {
      warehouse = JSON.parse(window.localStorage.getItem("SYS_ERP_lastly_used_warehouse") || "null");
    } catch (error) {
      return warehouse;
    }
    return warehouse;
  };
  return {
    setLastlyUsedWarehouse,
    getLastlyUsedWarehouse,
    setSelectWarehouse,
    warehouseInfo
  };
};
export const useLastlyUsedWarehouseModal = createModel(useLastlyUsedWarehouse);
